<template>
	<div class="padding-16 condition-border">
		<div class="font-16 font-gilroy font-weight-500">
			<div>
				Add to program
			</div>
			<div class="flex mt-3 gap-10 wrap">
				<what-condition-item v-for="(elem, index) in what_condition_count" :key="index" 
				:condition_connectiion_remove="condition_connectiion_remove"
				:current_what_elem="elem"
				:index="index"
				:state_valid="state_valid"
				:option_data="automation_options"
				:edit_view="edit_view"
				@updateConditionWhat="updateConditionWhat"
				@validCondition="validCondition"
				@removeConditionWhat="removeConditionWhat(index)">
				</what-condition-item>
				<div class="what-item-box padding-16 border-what-add position-relative flex-fix justify-content-center">
					<div :class="{'input-disabled not-allowed' : !can_add_group || !get_each_condition_validation}" class="add-program-center">
						<a class="pointer" @click="addWhatCondition()">
							<section>
								<img  class="" width="54" height="54" src="../../../../assets/images/icons/solid/add_to_program_automation.svg"/>
							</section>
							Add a program
						</a>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import whatConditionItem from "./whatConditionItem.vue";
export default {
  props: {
    automation_options: {
      required: true
    },
    automation_edit_detail: {
      required: false
    },
    edit_view: {
      required: true
    }
  },
  components: {
    whatConditionItem
  },
  data: function() {
    return {
      what_condition_count: [
        {
          rule_property_id: "",
          conditional_id: "",
          value: "",
          value_child: ""
        }
      ],
      //api_ready_action_edit:'',
      //automation_options:[],
      can_add_group: false,
      state_valid: true,
      conditions_validations: []
    };
  },
  computed: {
    condition_connectiion_remove() {
      return this.what_condition_count.length > 1;
    },
    get_edit_actions() {
      return this.$store.getters.getActions;
    },
    get_each_condition_validation() {
      // let cond = true
      // this.conditions_validations.forEach(elem => {
      //   if(!elem){
      //     cond = false
      //   }
      // })
      //this.$emit('updateWHATcondition', cond)
      return this.conditions_validations;
    }
  },
  watch: {
    get_each_condition_validation(val) {
      var cond = this.statusOfMultipleCondition();
      this.updateWhatConditonStatus(this.can_add_group && cond);
    },
    can_add_group(val) {
      //check all conditions
      var cond = this.statusOfMultipleCondition();
      this.updateWhatConditonStatus(cond && val);
    },
    get_edit_actions(val) {
      if (this.get_edit_actions.length > 0 && this.get_edit_actions != "") {
        this.what_condition_count = [];
        this.get_edit_actions.forEach(elem => {
          this.what_condition_count.push({
            program: "",
            duration: "",
            date_start: "",
            date_finish: "",
            sms: 0,
            days_from_start_date:0,
            additional_days_on_start: 0
          });
        });
      }
    }
  },
  created: function() {},
  beforeDestroy() {
    this.$nextTick(() => {
      this.cleanMemoryWhat();
    });
  },
  methods: {
    statusOfMultipleCondition() {
      let cond = true;
      this.get_each_condition_validation.forEach(elem => {
        if (!elem) {
          cond = false;
          return cond;
        }
      });
      return cond;
    },
    updateWhatConditonStatus(cond) {
      this.$emit("updateWHATcondition", cond);
    },
    removeConditionWhat(index) {
      this.can_add_group = true;
      this.state_valid = false;
      this.conditions_validations.splice(index, 1);
      this.what_condition_count.splice(index, 1);
      //this.$emit('updateWHATcondition', this.can_add_group)
      this.makeAPIObj(index);
      //  this.$store.commit('editCurrentAction', {'start:': index, 'end': 1});
    },
    updateConditionWhat(data, index) {
      this.what_condition_count[index] = data;
      this.makeAPIObj();
    },
    // gets the form validation from child component
    validCondition(condition_is_valid, index) {
      //this.what_condition_count = condition_is_valid;
      this.can_add_group = condition_is_valid;
      this.conditions_validations[index] = condition_is_valid;
    },
    addWhatCondition() {
      // let temp_index = this.what_condition_count[this.what_condition_count.length-1].what_item.index
      this.what_condition_count.push({
        program: "",
        duration: "",
        start_date_type: "",
        date_start: "",
        date_finish: "",
        sms: 0,
        event_date: 0,
        days_from_start_date: 0,
        additional_days_on_start: 0
      });
      this.can_add_group = false;
      this.conditions_validations.push(false);
      // this.add_condition_available = false
    },
    makeAPIObj(index) {
      var final_api_ = [];
      this.what_condition_count.forEach(elem => {
        let temp_arr = [];

        // if(this.automation_options && this.automation_options[0] && this.automation_options[0].id && this.automation_options[0].inputs){
        this.automation_options[0].inputs.forEach(input => {
          let temp_obj = {
            //rule_property_id: input.id,
            // value: 0
          };
          
          if (input.id == 10) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.date_start;
          } else if (input.id == 11) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.date_finish;
          } else if (input.id == 12) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.sms ? 1 : 0;
          } else if (input.id == 13) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.event_date ? 1 : 0;
          } else if (input.id == 14) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.days_from_start_date ? elem.days_from_start_date : 0;
          } else if (input.id == 15) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.start_date_type.id ? elem.start_date_type.id : 0;
          } else if (input.id == 16) {
            temp_obj.rule_property_id = input.id;
            temp_obj.value = elem.additional_days_on_start ? elem.additional_days_on_start : 0;
          } else {
            if (
              elem[input.name.toLowerCase()] &&
              elem[input.name.toLowerCase()].id
            ) {
              temp_obj.value = elem[input.name.toLowerCase()].id;
              temp_obj.rule_property_id = input.id;
            }
          }
          temp_arr.push(temp_obj);
        });

        let value_group = {
          id: this.automation_options[0].id,
          value: temp_arr
        };
        //push the condition

        final_api_.push(value_group);
      });
      //this.$store.dispatch('setCurrentAction', final_api_)
      // this.$store.commit('setCurrentAction', final_api_)
      this.$emit("updateWhatAPI", final_api_);
      return final_api_;
    },
    cleanMemoryWhat() {
      this.what_condition_count = [
        {
          rule_property_id: "",
          conditional_id: "",
          value: "",
          value_child: ""
        }
      ];
      this.$store.commit("setCurrentAction", {});
    }
  }
};
</script>
<style src="../../automation.css">
</style>



// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHAT/conditionGroupWhat.vue